var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { transform: "rotate(30 -7.99 31.428)", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
            React.createElement("rect", { x: 9, y: 0, width: 23, height: 18, rx: 2 }),
            React.createElement("path", { d: "M1.547 2.01L6.32 5.127c.424.277.68.75.68 1.256v5.234a1.5 1.5 0 01-.68 1.256L1.547 15.99A1 1 0 010 15.153V2.847a1 1 0 011.547-.837z" }))));
});
